<template>
  <b-form-fieldset label-text-align="right" :label-cols="labelCols" :label="label + ':'" horizontal :state="veeState" :feedback="veeFeedBack">
    <div v-if="static || isReadOnly" class="text-left static-field" v-html="getStaticValue()">
    </div>
    <div v-else>
      <b-form-input v-if="type === 'simpledate'" type="date" v-model="rec[field]" :name="field" :state="veeState" v-validate="vvalidate" :disabled="isReadOnly"/>
      <datepicker v-else-if="type === 'date'"
        v-model="rec[field]"
        :name="field" :state="veeState"
        :clear-button="hasClearButton" clear-button-icon="fa fa-times"
        :calendar-button="true" calendar-button-icon="fa fa-calendar"
        inputClass="dateinput" :bootstrapStyling="true"
        @input="onInput($event, true)"
      />
      <daterange v-else-if="type === 'daterange'"
        v-model="rec[field]"
        :name="field" :state="veeState"
        @input="onInput($event, true)"
      />
      <b-form-select v-else-if="type === 'boolean' && hasNull"
        v-model="rec[field]"
        :name="field"
        :options="booleanOptionList"
        :state="veeState"
        class="float-right text-right"
        :disabled="isReadOnly"
        @input="onInput($event, true)"
      />
      <b-form-checkbox v-else-if="type === 'boolean'"
        v-model="rec[field]"
        :name="field"
        :state="veeState"
      />
      <multiselect v-else-if="(optionList !== null || optionListApiUrl !== null) && finalOptionList.length"
        @input="onInput($event, true)"
        v-model="rec[field]" track-by="value"
        :name="field"
        :options="finalOptionList"
        :state="veeState"
        label="text"
        :showLabels="false"
        :data-vv-name="field"
        :disabled="isReadOnly"
      />
      <b-form-textarea v-else-if="type === 'textarea'"
        v-model="rec[field]"
        :name="field"
        :state="veeState"
        :disabled="isReadOnly"
        :rows="4"
        @input="onInput($event, false)"
        @keyup.enter.prevent="onEnter($event)"
      />
      <b-input-group v-else-if="type === 'money'" left="€">
        <b-form-input v-model.number="rec[field]" :name="field" :state="veeState" type="number" step="0.01" data-number-to-fixed="2" data-number-stepfactor="100" :disabled="isReadOnly" class="float-right" @input="onInput($event, false)" @keyup.enter.prevent="onEnter($event)"/>
      </b-input-group>
      <b-form-input v-else
        v-model="rec[field]"
        :name="field"
        :state="veeState"
        :type="type"
        :disabled="isReadOnly"
        class="float-right"
        @input="onInput($event, false)"
        @keyup.enter.native.prevent="onEnter($event)"
      />
    </div>
  </b-form-fieldset>
</template>

<script>
// import Vue from 'vue'
import api from '../api'
import Validation from '../validation'
import Multiselect from 'vue-multiselect'
// import Multiselect from '../../external/vue-multiselect/src/Multiselect'
import Datepicker from 'vuejs-datepicker'
import Daterange from './DateRange'
import formatting from '../formatting'

export default {
  name: 'DetailField',
  inject: ['$validator'],
  components: {Datepicker, Daterange, Multiselect},
  props: {
    label: {type: String, required: true},
    field: {type: String, required: true},
    field2: {type: String, default: ''},
    static: {type: Boolean, default: false},
    hasNull: {type: Boolean, default: false},
    isReadOnly: {type: Boolean, default: false},
    labelCols: {type: Number, default: 3},
    type: {type: String, default: 'text'},
    vvalidate: {type: String, required: true},
    validator: {type: Object, required: true},
    optionList: {type: Array, default: null},
    optionListApiUrl: {type: String, default: null},
    optionListApiParams: {type: Object, default: null},
    optionListApiDoUpdate: {type: Boolean, default: true},
    rec: {type: Object, required: true}
  },
  data () {
    // console.log('DetailField.data ' + this.field, this.rec[this.field])
    console.assert(this.vvalidate, 'vvalidate should not be empty for ' + this.field)
    // console.log('DetailField.data', this.field, this.rec)
    if (!(this.field in this.rec)) {
      this.$set(this.rec, this.field, '') // Add reactive value
    }
    if (!this.static) Validation.addValidation(this.validator, this.rec, this.field, this.label, this.vvalidate)
    return {
      finalOptionList: [],
      finalApiParams: this.optionListApiParams,
      finalApiUpdate: this.optionListApiDoUpdate,
      booleanOptionList: [{'text': 'Yes', 'value': true}, {'text': 'No', 'value': false}]
    }
  },
  created () {
    // console.log('created DetailField ' + this.field, this.rec[this.field], this.$props)
    this.updateOptions()
  },
  // beforeCreate () { console.log('beforeCreate DetailField', this) },
  // created () { console.log('created DetailField ' + this.field) },
  // beforeUpdate () { console.log('beforeUpdate DetailField ' + this.field) },
  // beforeMount () { console.log('beforeMount DetailField ' + this.field) },
  // updated () { console.log('updated DetailField ' + this.field) },
  // activated () { console.log('activated DetailField ' + this.field) },
  // deactivated () { console.log('deactivated DetailField ' + this.field) },
  // beforeDestroy () { console.log('beforeDestroy DetailField ' + this.field) },
  // destroyed () { console.log('destroyed DetailField ' + this.field) },
  // mounted () {
  //   console.log('mounted DetailField ' + this.field, this.rec[this.field], this.$props)
  //   // this.updateOptions()
  // },
  computed: {
    veeState () {
      // console.log('veeState', this.field, this.validator.errors.has(this.field))
      return this.validator.errors.has(this.field) ? 'invalid' : ''
    },
    veeFeedBack () {
      // console.log('veeFeedBack', this.field, this.validator.errors.first(this.field))
      return this.validator.errors.first(this.field)
    },
    hasClearButton () {
      // console.log(this.field, this.vvalidate, typeof this.vvalidate)
      return this.vvalidate !== 'required'
    }
  },
  methods: {
    onInput (value, isEnterEvent) {
      // console.log('DetailField.onInput', this.field, value, isEnterEvent)
      Validation.validateValue(this.validator, this.field, value)
      this.$emit('input', value)
      if (isEnterEvent) this.$emit('enter', value)
    },
    onEnter (theEvent) {
      // console.log('DetailField.onEnter', this.field, theEvent)
      this.$emit('enter', theEvent)
    },
    getStaticValue () {
      let thisValue = this.rec[this.field]
      // console.log(this.field, thisValue, this.finalOptionList.length)
      if (this.finalOptionList.length || this.optionListApiUrl) {
        for (const option of this.finalOptionList) {
          if (option.value === thisValue) {
            return option.text
          }
        }
        const otherField = this.field.substring(0, this.field.length - 3)
        if (this.rec[otherField]) return this.rec[otherField]
        return ''
      } else if (this.type === 'text') return thisValue
      else if (this.type === 'phone') return thisValue
      else if (this.type === 'datetime') return formatting.formatDateTime(thisValue)
      else if (this.type === 'date') return formatting.formatDate(thisValue)
      else if (this.type === 'simpledate') return formatting.formatDate(thisValue)
      else if (this.type === 'timestamp_user') return thisValue ? (formatting.formatTimeStamp(thisValue) + ' by ' + this.rec[this.field2]) : ''
      else if (this.type === 'textarea') return thisValue ? thisValue.replace(/\n/g, '<br />') : ''
      else if (this.type === 'email') return '<a href="mailto:' + thisValue + '">' + thisValue + '</a>'
      else if (this.type === 'boolean') return formatting.formatBoolean(thisValue)
      else if (this.type === 'password') return thisValue ? '***' : ''
      else if (this.type === 'money') return formatting.formatMoney(thisValue)
      else {
        console.log('getStaticValue not implemented for ' + this.type)
        return thisValue
      }
    },
    updateOptionsParams (params) {
      this.finalApiParams = params
      this.finalApiUpdate = true
      this.updateOptions()
    },
    _setOptions (options) {
      this.finalOptionList = options
      const v = this.rec[this.field]
      this.rec[this.field] = null
      this.rec[this.field] = v
    },
    _callAPIChoice (urlChoiceBase, checksum) {
      // console.log('_callAPIChoice', urlChoiceBase, checksum)
      api.get(this.optionListApiUrl, this.finalApiParams,
      data => {
        const options = data.records.map(function (r) {
          return {'text': r.name, 'value': r.id}
        })
        this._setOptions(options)

        if (urlChoiceBase) {
          const newCache = {'options': options, 'checksum': checksum}
          this.$store.commit({type: 'setCachedChoice', name: urlChoiceBase, value: newCache})
        }
      },
      error => {
        console.log(error)
      }, this)
    },
    _callAPIOptionList () {
      // console.log('_callAPIOptionList', this.optionListApiUrl, this.finalApiParams)
      console.assert(this.optionListApiUrl.endsWith('choice/'))
      const useChecksumCache = 1
      if (useChecksumCache && !this.finalApiParams) {
        const urlChoiceBase = this.optionListApiUrl.substring(0, this.optionListApiUrl.length - 7)
        const urlChoiceChecksum = urlChoiceBase + 'choice_checksum/'
        const cachedChoice = this.$store.getters.getCachedChoice(urlChoiceBase)
        // console.log('cachedChoice', urlChoiceBase, cachedChoice)
        api.get(urlChoiceChecksum, null,
        data => {
          const checksum = data.checksum
          if (cachedChoice && (cachedChoice.checksum === checksum)) {
            console.log('CacheHit', urlChoiceBase, checksum)
            this._setOptions(cachedChoice.options)
          } else {
            this._callAPIChoice(urlChoiceBase, checksum)
          }
        },
        error => {
          console.log(error)
          this._callAPIChoice(null, null)
        }, this)
      } else {
        this._callAPIChoice(null, null)
      }
    },
    updateOptions () {
      if (this.optionList) {
        // console.log('updateOptions', this.field, typeof this.optionList[0])
        if (typeof this.optionList[0] === 'string') {
          this.finalOptionList = this.optionList.map(function (s) {
            return {'text': s, 'value': s}
          })
        } else this.finalOptionList = this.optionList
      } else if (this.optionListApiUrl && this.finalApiUpdate) {
        this._callAPIOptionList()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DetailField.vue?775e5420